import { ClientEndpointType, EmailClientEndpoint, EndpointAttachmentType } from "@app/shared";
import { useModel } from "@app/shared/src/hooks";
import { CheckboxInput, Input, InputRow, PasswordInput, TextArea } from "@app/dashboard/src/components/shared/inputs";
import { ClientEndpointEditorProps } from "./ClientEndpointEditor";
import { HoverTooltip } from "@app/dashboard/src/components/shared/HoverTooltip";

type EditEmailClientEndpointProps = {
} & ClientEndpointEditorProps;

export const EditEmailClientEndpoint: React.FC<EditEmailClientEndpointProps> = (props) => {
    const [model, helper] = useModel(EmailClientEndpoint, props.endpoint as EmailClientEndpoint);
    const onChange = (newEndpoint: Partial<EmailClientEndpoint>) => {
        props.onChange({ ...newEndpoint as EmailClientEndpoint, endpointType: ClientEndpointType.Email });
    };

    return (
        <>
            <InputRow><Input label="Endpoint Name" {...helper.bindingsFor("endpointName", onChange)} /></InputRow>
            <InputRow><HoverTooltip offset={[400, -60]} hoverable={<TextArea label="Email Address(es)" rows={5} {...helper.bindingsFor("emailAddress", onChange)} />}>Email address or comma separated list of email addresses</HoverTooltip></InputRow>
            {/* Attachment is an enum on the wire, but Photo is the only thing an email can carry: the clip link goes in
                the body whenever the trigger records video. */}
            <InputRow><HoverTooltip hoverable={<CheckboxInput label="Attach photo"
                fieldName="attachment"
                checked={model?.attachment === EndpointAttachmentType.Photo}
                onChange={(e) => helper.handlerFor("attachment", onChange)(e.target.checked ? EndpointAttachmentType.Photo : EndpointAttachmentType.None)} />}>
                Includes the photo of the event's target, when one was taken. Units on older firmware attach it regardless.
            </HoverTooltip></InputRow>
            <InputRow><CheckboxInput label="Use Custom Smtp Server?" {...helper.bindingsFor("useCustomSmtpServer", onChange)} /></InputRow>
            {model?.useCustomSmtpServer && <>
                <InputRow><Input label="FromEmail" {...helper.bindingsFor("fromEmail", onChange)} /></InputRow>
                <InputRow><Input label="Server" {...helper.bindingsFor("server", onChange)} /></InputRow>
                <InputRow><Input label="Username" {...helper.bindingsFor("username", onChange)} /></InputRow>
                <InputRow><Input label="Port" {...helper.bindingsFor("port", onChange)} /></InputRow>
                <InputRow><PasswordInput label="Password" {...helper.bindingsFor("password", onChange)} /></InputRow>
                <InputRow><CheckboxInput label="UseSsl" {...helper.bindingsFor("useSsl", onChange)} /></InputRow>
            </>}
        </>
    );
}
